module.exports = __webpack_public_path__ + "static/media/complexPic12.ddbc5970.png";